import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  lineNumberCell: {
    color: `${theme.palette.grey[500]}`,
    fontSize: "90%",
    borderRight: `1px solid ${theme.palette.grey[500]}`,
    paddingRight: theme.spacing(1),
    textAlign: "right"
  },
  hitCountCell: {
    width: "50px",
    borderRight: `1px solid ${theme.palette.grey[500]}`,
    textAlign: "center",
    color: theme.palette.common.white,
    // need to enforce this color since it needs to stand out against colored background
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  countRoundedRectangle: {
    borderRadius: "45px",
    fontSize: "90%",
    padding: "1px 3px 1px 3px",
    width: "50px"
  },
  hitCountRoundedRectangle: {
    backgroundColor: `${theme.palette.success.main}`,
    color: `${theme.palette.success.contrastText}`
  },
  notHitCountRoundedRectangle: {
    backgroundColor: `${theme.palette.error.main}`,
    color: `${theme.palette.error.contrastText}`
  },
  codeLine: {
    paddingLeft: `${theme.spacing(1)}`,
    whiteSpace: "pre",
    fontSize: "90%"
  },
  hitCodeLine: {
    backgroundColor: `${theme.palette.success.main}`,
    color: `${theme.palette.success.contrastText}`
  },
  notHitCodeLine: {
    backgroundColor: `${theme.palette.error.main}`,
    color: `${theme.palette.error.contrastText}`
  }
}));
const CodeRow = ({
  lineNumber,
  lineContent,
  lineHits = null
}) => {
  const classes = useStyles();
  const hitCountRoundedRectangleClass = [classes.countRoundedRectangle];
  const lineContentClass = [classes.codeLine];
  let hitRoundedRectangle = null;
  if (lineHits !== null) {
    if (lineHits > 0) {
      hitCountRoundedRectangleClass.push(classes.hitCountRoundedRectangle);
      lineContentClass.push(classes.hitCodeLine);
    } else {
      hitCountRoundedRectangleClass.push(classes.notHitCountRoundedRectangle);
      lineContentClass.push(classes.notHitCodeLine);
    }
    hitRoundedRectangle = /* @__PURE__ */ React.createElement("div", { className: hitCountRoundedRectangleClass.join(" ") }, lineHits);
  }
  return /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { className: classes.lineNumberCell }, lineNumber), /* @__PURE__ */ React.createElement("td", { className: classes.hitCountCell }, hitRoundedRectangle), /* @__PURE__ */ React.createElement(
    "td",
    {
      className: lineContentClass.join(" "),
      dangerouslySetInnerHTML: { __html: lineContent }
    }
  ));
};

export { CodeRow };
//# sourceMappingURL=CodeRow.esm.js.map
